import { render } from "./IconArrowBack.vue?vue&type=template&id=b8a4c296"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__